//src/services/adminInventory.api.js
import { adminApiRequest } from "./adminApi";

export const getInventoryAlerts = () => {
  return adminApiRequest("/inventory/alerts");
};

export const deleteInventoryAlert = (variantId) => {
  return adminApiRequest(`/inventory/alerts/${variantId}`, {
    method: "DELETE",
  });
};

